module.exports = __webpack_public_path__ + "media/img/illustrations/heart-line-a4e193665a32df4e8524092e17d02829.png";